<template>
  <section class="panel pad">
    <div class="panel-head">
      <h2>广告管理</h2>
      <button type="button" class="btn ghost sm" @click="load">刷新</button>
    </div>
    <p class="muted">
      查参数搜索结果左右赞助位。未上架或库中无广告时前台不展示。
      前台约 28% 搜索会随机出 1 条；用户可关闭 24 小时。keywords 逗号分隔，空=通投。
    </p>
    <p v-if="error" class="error">{{ error }}</p>
    <p v-if="message" class="ok">{{ message }}</p>

    <h3>新增广告</h3>
    <div class="form-grid">
      <label><span>位置</span>
        <select v-model="draft.slot">
          <option value="left">左侧</option>
          <option value="right">右侧</option>
        </select>
      </label>
      <label><span>标题 *</span><input v-model="draft.title" placeholder="产品或活动名" /></label>
      <label><span>副标题</span><input v-model="draft.subtitle" placeholder="一句卖点" /></label>
      <label><span>链接</span><input v-model="draft.url" placeholder="/price 或 https://…" /></label>
      <label><span>按钮文案</span><input v-model="draft.cta" placeholder="了解详情" /></label>
      <label><span>价格标签</span><input v-model="draft.price_label" placeholder="可选" /></label>
      <label><span>关键词</span><input v-model="draft.keywords" placeholder="H100,训练,昇腾" /></label>
      <label><span>权重</span><input v-model.number="draft.weight" type="number" min="0" /></label>
      <label class="check"><span>上架</span><input v-model="draft.published" type="checkbox" /></label>
    </div>
    <div class="actions">
      <button type="button" class="btn primary sm" @click="create">添加广告</button>
    </div>

    <h3>已有广告（{{ list.length }}）</h3>
    <p v-if="!list.length" class="muted">暂无广告。添加并上架后，前台才会随机展示。</p>
    <div v-for="item in list" :key="item.id" class="ad-card">
      <div class="ad-meta">
        <strong>#{{ item.id }}</strong>
        <span :class="['tag', item.published ? 'on' : 'off']">{{ item.published ? '上架' : '下架' }}</span>
        <span class="tag">{{ item.slot === 'left' ? '左侧' : '右侧' }}</span>
        <span class="muted">权重 {{ item.weight }}</span>
      </div>
      <div class="form-grid">
        <label><span>位置</span>
          <select v-model="item.slot">
            <option value="left">左侧</option>
            <option value="right">右侧</option>
          </select>
        </label>
        <label><span>标题</span><input v-model="item.title" /></label>
        <label><span>副标题</span><input v-model="item.subtitle" /></label>
        <label><span>链接</span><input v-model="item.url" /></label>
        <label><span>按钮文案</span><input v-model="item.cta" /></label>
        <label><span>价格标签</span><input v-model="item.price_label" /></label>
        <label><span>关键词</span><input v-model="item.keywords" /></label>
        <label><span>权重</span><input v-model.number="item.weight" type="number" min="0" /></label>
        <label class="check"><span>上架</span><input v-model="item.published" type="checkbox" /></label>
      </div>
      <div class="actions">
        <button type="button" class="btn ghost sm" @click="save(item)">保存</button>
        <button type="button" class="btn danger sm" @click="remove(item)">删除</button>
      </div>
    </div>
  </section>
</template>

<script>
import {
  adminCreateSearchAd,
  adminDeleteSearchAd,
  adminListSearchAds,
  adminUpdateSearchAd
} from '../../api/platformService'

const empty = () => ({
  slot: 'right',
  title: '',
  subtitle: '',
  url: '',
  price_label: '',
  keywords: '',
  weight: 5,
  published: false,
  cta: '了解详情'
})

export default {
  name: 'AdminAds',
  data() {
    return {
      list: [],
      draft: empty(),
      error: '',
      message: ''
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.error = ''
      try {
        this.list = await adminListSearchAds()
      } catch (err) {
        this.error = err.response?.data?.error || '加载失败'
      }
    },
    async create() {
      this.error = ''
      this.message = ''
      if (!this.draft.title.trim()) {
        this.error = '标题不能为空'
        return
      }
      try {
        await adminCreateSearchAd(this.draft)
        this.draft = empty()
        this.message = '已添加（默认未上架，勾选上架后前台可见）'
        await this.load()
      } catch (err) {
        this.error = err.response?.data?.error || '添加失败'
      }
    },
    async save(item) {
      this.error = ''
      this.message = ''
      try {
        await adminUpdateSearchAd(item.id, item)
        this.message = `已保存 #${item.id}`
        await this.load()
      } catch (err) {
        this.error = err.response?.data?.error || '保存失败'
      }
    },
    async remove(item) {
      if (!window.confirm(`删除广告「${item.title}」？`)) return
      await adminDeleteSearchAd(item.id)
      this.message = '已删除'
      await this.load()
    }
  }
}
</script>

<style scoped>
.muted { color: #86909c; font-size: 13px; margin: 0 0 12px; }
h3 { margin: 18px 0 10px; font-size: 15px; }
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
  margin-bottom: 10px;
}
.form-grid label { display: grid; gap: 4px; margin: 0; font-size: 12px; color: #4e5969; }
.form-grid input, .form-grid select {
  border: 1px solid #e5e6eb; border-radius: 4px; padding: 6px 8px; font: inherit; color: #1d2129;
}
.check { align-content: end; }
.check input { width: auto; }
.actions { display: flex; gap: 8px; margin-bottom: 8px; }
.ad-card {
  border: 1px solid #e5e6eb; border-radius: 8px; padding: 12px; margin-bottom: 12px; background: #fafbfc;
}
.ad-meta { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-bottom: 10px; }
.tag {
  font-size: 11px; padding: 1px 6px; border-radius: 4px; background: #f2f3f5; color: #4e5969;
}
.tag.on { background: #e8ffea; color: #00b42a; }
.tag.off { background: #f2f3f5; color: #86909c; }
</style>
